$(document).ready(function() {

  const SELECTORS = {
    btnPlus: '.btn-plus',
    btnMinus: '.btn-minus',
    quantityInput: '.bb-quantity-input',
    bundleDropdownItem: '.bb-box-item-dropdown-item',
    bundleItemSelect: '.bb-box-item-select',
    bbBoxContainer: '.bb-box-container',
    progressLine: '.bb-boxes-progress-line',
    progressLineItem: '.bb-boxes-progress-line-item',
    deliveryToggle: '.bb-delivery-type-btn',
    purchaseToggle: '.bb-purchase-type-btn',
    atcBtnText: '.bb-atc-btn-text',
    atcBtnPrice: '.bb-atc-btn-price',
    atcBtn: '.bb-atc-btn',
    customizeBtn: '.bb-box-customizer-btn',
    customizeModalApplyBtn: '.bb-box-modal-apply-btn',
    customizeModal: '.bb-box-modal',
    customizeModalProduct: '.bb-box-modal-products',
    requiredInfo: '.bb-required-info'
  }

  const PRODUCT_PLATFORM_ID = 7689411690691

  const CURRENT_PRODUCT = JSON.parse($('#bbCurrentProduct').text())
  const discount = 15

  let allowedQty = 2;

  let currentProduct = {};
  let widgetProducts = [];
  let dropdownProducts = [];
  let purchaseType = 'onetime';
  let deliveryType = 1;

  const formatPrice = (price) => {
    return `$${(price / 100).toFixed(2)}`
  }

  const processPrices = () => {

    widgetProducts.forEach(product => {
      if(purchaseType === 'subscription') {
        product.variantDiscountedPrice = product.variantPrice - ((product.variantPrice * discount) / 100)
      }
    })

    let totalDiscountedPrice = widgetProducts.slice(0, allowedQty).reduce((total, product) => {
      return total + product.variantDiscountedPrice
    }, 0);

    let totalPrice = widgetProducts.slice(0, allowedQty).reduce((total, product) => {
      return total + product.variantPrice
    }, 0);

    if( purchaseType === 'onetime' ) {
      $(SELECTORS.atcBtnPrice).text(formatPrice(CURRENT_PRODUCT.variants[0].price))
    } else {
      if( totalPrice === totalDiscountedPrice ) {
        $(SELECTORS.atcBtnPrice).text(formatPrice(totalPrice))
      } else {
        $(SELECTORS.atcBtnPrice).text(formatPrice(totalDiscountedPrice))
      }
    }

    buildBundleBoxWidget()
  }

  const processCart = () => {
    let data = {items: []};

    if (purchaseType === 'onetime') {
      data.items = [
        {
          id: CURRENT_PRODUCT.variants[0].id,
          quantity: $(SELECTORS.quantityInput).val()
        }
      ]
    } else {
      data.items = widgetProducts.slice(0, allowedQty).map(product => {
        return {
          id: product.variantId,
          quantity: 1,
          selling_plan: product.sellingPlans.filter(plan => plan.planIntervalCount === deliveryType)[0].planId,
          properties: {
            _dynamicBoxIndex: 0,
            _dynamicBoxId: product.boxId
          }
        }
      })
    }

    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then(response => {
      console.log(response.json())
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }

  const renderProductCard = (product, index) => {
    let dropdownHtml = '';

    dropdownProducts.forEach(dropdownProduct => {
      dropdownHtml += `
        <div class="bb-box-item-dropdown-item" data-product-id="${dropdownProduct.id}" data-product-index="${index}">
          <div class="bb-dropdown-item-image">
            <img src="${dropdownProduct.image}" alt="${dropdownProduct.title}" loading="lazy">
          </div>
          <div class="bb-dropdown-item-title">
            ${dropdownProduct.title}
          </div>
        </div>
      `
    })
    return `
      <div class="bb-box-item" data-product-id="${product.id}">
        <div class="bb-box-item-image">
          <img src="${product.image}" alt="${product.title}" loading="lazy">
        </div>
        <div class="bb-box-item-title">${product.title}</div>
        <div class="bb-box-item-price">
          ${product.variantPrice === product.variantDiscountedPrice ? formatPrice(product.variantPrice) : formatPrice(product.variantDiscountedPrice)}
        </div>
        <div class="bb-box-item-selector">
          <div class="bb-box-item-select">
            Change your box
          </div>
          <div class="bb-box-item-dropdown">
            ${dropdownHtml}
          </div>
        </div>
      </div>
    `
  }

  const renderModalProductCard = (product, index) => {
    let dropdownHtml = '';

    dropdownProducts.forEach(dropdownProduct => {
      dropdownHtml += `
        <div class="bb-box-item-dropdown-item" data-product-id="${dropdownProduct.id}" data-product-index="${index}">
          <div class="bb-dropdown-item-image">
            <img src="${dropdownProduct.image}" alt="${dropdownProduct.title}" loading="lazy">
          </div>
          <div class="bb-dropdown-item-title">
            ${dropdownProduct.title}
          </div>
        </div>
      `
    })

    return `
      <div class="bb-box-modal-product-item" data-product-id="${product.id}">
        <div class="bb-box-modal-product-image">
          <img src="${product.image}" alt="${product.title}" loading="lazy">
        </div>
        <div class="bb-box-modal-product-content">
          <div class="bb-box-modal-product-title">
            ${product.title}
          </div>
          <div class="bb-box-modal-product-price">
            ${product.variantPrice === product.variantDiscountedPrice ? formatPrice(product.variantPrice) : formatPrice(product.variantDiscountedPrice)}
          </div>
          <div class="bb-box-modal-item-selector">
            <div class="bb-box-item-select">
              Change your box
            </div>
            <div class="bb-box-item-dropdown">
              ${dropdownHtml}
            </div>
          </div>
        </div>
      </div>
    `
  }

  const buildBundleBoxWidget = () => {
    let productsHtml = '';
    let modalProductsHtml = '';

    widgetProducts.slice(0, allowedQty).forEach((product, index) => {
      productsHtml += renderProductCard(product, index)
      modalProductsHtml += renderModalProductCard(product, index);
    })

    $(SELECTORS.bbBoxContainer).html(productsHtml)
    $(SELECTORS.customizeModalProduct).html(modalProductsHtml)
    console.log('Product box')
  }

  const fetchDynamicBoxInformation = async(boxParentProductId) => {
    return new Promise((resolve, reject) => {
      fetch('https://api.skio.com/storefront-http/get-dynamic-box', {
        method: 'POST',
        body: JSON.stringify({
          'productPlatformId': boxParentProductId,
        })
      })
      .then((response) => response.json())
      .then((response) => {
        if(!response.ok) throw new Error('Failed to get box');
        const { DynamicBox } = response;
        resolve(DynamicBox);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      })
    });
  }

  fetchDynamicBoxInformation(PRODUCT_PLATFORM_ID).then((DynamicBox) => {
    let sellingPlans = Object.keys(DynamicBox.sellingPlanGroup).map(plan => {
      return {
        planId: parseInt(plan.replace('gid://shopify/SellingPlan/', '')),
        planIntervalCount: DynamicBox.sellingPlanGroup[plan].intervalCount,
        variants: parseInt(DynamicBox.sellingPlanGroup[plan].variantMapping)
      }
    })

    dropdownProducts = DynamicBox.selectableProductVariants.map((item) => {
      return {
        variantId: parseInt(item.productVariants[0].platformId.replace("gid://shopify/ProductVariant/", "")),
        variantDiscountedPrice: item.productVariants[0].price * 100,
        variantPrice: item.productVariants[0].price * 100,
        title: item.productTitle.split(" | ")[0],
        image: item.productImageSrc,
        id: parseInt(item.productPlatformId.replace("gid://shopify/Product/", "")),
        sellingPlans: sellingPlans,
        boxId: DynamicBox.boxId
      }
    })

    currentProduct = dropdownProducts.filter(product => CURRENT_PRODUCT.id === product.id)
    widgetProducts = [currentProduct[0]]
    buildBundleBoxWidget(DynamicBox)
  })

  $(SELECTORS.purchaseToggle).on('click', function() {
    $('.bb-purchase-type-btn').not($(this)).removeClass('active')
    $(this).addClass('active')
    purchaseType = $(this).data('purchase-type')
    if(purchaseType === 'onetime') {
      $(this).eq(1).find('.bb-purchase-type-btn-subtitle > span:not(.displaySelected)').css('display', 'inline-block')
      $(this).eq(1).find('.bb-purchase-type-btn-subtitle > span.displaySelected').css('display', 'none')
      $(SELECTORS.requiredInfo).css('display', 'none')
      $(SELECTORS.atcBtnText).html('Add to cart')
      deliveryType = 0
      allowedQty = 1
      $(SELECTORS.quantityInput).attr("min", "1")
      $(SELECTORS.quantityInput).val(allowedQty)
      $('.bb-wrapper').removeClass('subscription')
      $(SELECTORS.quantityInput).trigger('change')
    } else {
      $(this).eq(1).find('.bb-purchase-type-btn-subtitle > span:not(.displaySelected)').css('display', 'none')
      $(this).eq(1).find('.bb-purchase-type-btn-subtitle > span.displaySelected').css('display', 'inline-block')
      $(SELECTORS.requiredInfo).css('display', 'block')
      $(SELECTORS.atcBtnText).html('Join the club')
      deliveryType = 1
      allowedQty = 2
      $(SELECTORS.quantityInput).attr("min", "2")
      $(SELECTORS.quantityInput).val(allowedQty)
      $('.bb-wrapper').addClass('subscription')
      $(SELECTORS.quantityInput).trigger('change')
    }
  })

  $(SELECTORS.deliveryToggle).on('click', function() {
    $('.bb-delivery-type-btn').not($(this)).removeClass('active')
    $(this).addClass('active')
    deliveryType = parseInt($(this).data('delivery-type'))
  })

  $(document).on('click', SELECTORS.btnPlus, function(e) {
    let oldValue = parseFloat($(this).siblings('input').val());
    let newVal = oldValue >= parseFloat($(this).siblings('input').attr('max')) ? oldValue : oldValue + 1;
    $(this).siblings('input').val(newVal).trigger("change");
  })

  $(document).on('click', SELECTORS.btnMinus, function(e) {
    let oldValue = parseFloat($(this).siblings('input').val());
    let newVal = oldValue <= parseFloat($(this).siblings('input').attr('min')) ? oldValue : oldValue - 1;
    $(this).siblings('input').val(newVal).trigger('change');
  })

  $(document).on('click', SELECTORS.bundleItemSelect, function(e) {
    $('.bb-box-item-dropdown').not($(this).siblings('.bb-box-item-dropdown')).removeClass('active')
    $(this).siblings('.bb-box-item-dropdown').toggleClass('active');
  })

  $(SELECTORS.quantityInput).on('change', function(e) {
    allowedQty = parseInt($(this).val())
    widgetProducts.push(currentProduct[0])
    console.log('quantity-change')
    // $(SELECTORS.progressLineItem).removeClass('filled')
    // $(SELECTORS.progressLineItem).slice(0, allowedQty > 2 ? 3 : allowedQty).addClass('filled')
    // $(SELECTORS.deliveryToggle).attr('disabled', 'disabled')
    // $(SELECTORS.deliveryToggle).attr('disabled', 'disabled')
    // $(SELECTORS.deliveryToggle).slice(0, allowedQty > 1 ? 3 : allowedQty).removeAttr('disabled')
    // $(SELECTORS.progressLine).attr('data-filled', allowedQty > 2 ? 3 : allowedQty)

    // if( allowedQty === 1 ) {
    //   $($(SELECTORS.deliveryToggle)[1]).find('.bb-delivery-type-btn-subtitle').css('display', 'block')
    //   $($(SELECTORS.deliveryToggle)[2]).find('.bb-delivery-type-btn-subtitle').css('display', 'block')
    //   $($(SELECTORS.deliveryToggle)[0]).trigger('click')
    // } else if (allowedQty >= 2) {
    //   $($(SELECTORS.deliveryToggle)[1]).find('.bb-delivery-type-btn-subtitle').css('display', 'none')
    //   $($(SELECTORS.deliveryToggle)[2]).find('.bb-delivery-type-btn-subtitle').css('display', 'none')
    // }
    processPrices()
  })

  $(document).on('click', SELECTORS.bundleDropdownItem, function(e) {
    let selectedProductId = $(this).data('product-id')
    let selectedProductIndex = $(this).data('product-index')
    widgetProducts[selectedProductIndex] = dropdownProducts.filter(product => product.id === parseInt(selectedProductId))[0]
    processPrices()
  })

  $(SELECTORS.customizeBtn).on('click', function() {
    $(SELECTORS.customizeModal).toggleClass('active')
  })

  $(SELECTORS.customizeModalApplyBtn).on('click', function() {
    $(SELECTORS.customizeModal).toggleClass('active')
  })

  $(SELECTORS.atcBtn).on('click', function() {
    $(SELECTORS.atcBtn).attr('disabled', 'disabled')
    processCart().then(() => {
      $(SELECTORS.atcBtn).removeAttr('disabled')
    })
  })
})